import { Routes_Interface } from "./routesInterface";
import { AssetTypesListing } from "../views/assets/AssetTypesListing";
import { GoogleCallback } from "../views/auth/GoogleCallback";
import { Yeat } from "../views/Yeat";

export const freeFormRoutes: Array<Routes_Interface> = [
    {
        name: 'ASSET.TYPE_LISTING_',
        path: "/module/asset-management/configuration/:uuid",
        element: <AssetTypesListing />,
        caseSensitive: true,
        activeMenu: 'ASMX'
    },

    {
        name: 'AUTH_GOOGLE_CALLBACK',
        path: "/auth/google/callback",
        element: <GoogleCallback />,
        caseSensitive: true,
    },
    {
        name: 'YEAT',
        path: "/temp/yeat",
        element: <Yeat />,
        guard: 'auth',
        caseSensitive: true,
    },
]